/**
 * Crow's Nest errors as a person reads them. Raw API or axios text
 * ("Invalid time value", "Request failed with status code 500") never
 * reaches the screen.
 */
export const CROWS_NEST_ERROR_COPY = Object.freeze({
  badRange: "Couldn't load that date range. Try a different one.",
  noAccess: 'Only OMS platform admins can see this.',
})

const statusOf = error => error?.response?.status ?? error?.status ?? null
const codeOf = error => error?.response?.data?.code ?? error?.code ?? null

/**
 * @param {unknown} error
 * @param {string} fallback  e.g. "Couldn't load Ollie findings. Try again in a moment."
 * @param {{ range?: boolean }} [options] `range: false` for actions (save,
 *   update) where a 400 isn't about dates.
 * @returns {string}
 */
export function crowsNestErrorMessage(error, fallback, { range = true } = {}) {
  const status = statusOf(error)
  if (status === 401 || status === 403) return CROWS_NEST_ERROR_COPY.noAccess
  if (
    range &&
    (status === 400 || codeOf(error) === 'GROWTH_ENGINE_BAD_REQUEST')
  ) {
    return CROWS_NEST_ERROR_COPY.badRange
  }
  return fallback
}
